import "./generated/json-imports/i18n-fetch.js";
